var map = {
	"./de.json": "c88d",
	"./el.json": "a8d6",
	"./en.json": "a485",
	"./es.json": "aa44",
	"./fr.json": "d709",
	"./hi.json": "b96b",
	"./history/history.json": "9728",
	"./nl.json": "9e43",
	"./pl.json": "efe9",
	"./pt.json": "2516",
	"./sk.json": "859f",
	"./zh-CN.json": "b04c",
	"./zh-TW.json": "abc7"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "915a";